import AttachmentModel from '@/views/Attachment/model/attachment'
import store from '@/store'

export default class StringGroupAttachmentModel extends AttachmentModel {
    get canDelete() {
        return store.getters.isSuperuser
    }

    public constructor(data: any, included?) {
        super(data, included)
    }
}
